import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        forms: '=',
        company: '=',
        surveyGroup: '='
    },
    template: `
        <h1>{{ 'survey.Add survey group' | translate }}</h1>
        <survey-form form="vm.form" forms="vm.forms" company="vm.company" save="vm.save()"></survey-form>
        <ul class="actions01">
            <li class="primary"><a ng-click="vm.save()" class="btn main">{{ 'general.Save' | translate }}</a></li>
            <li><a ui-sref="authorized.survey.list()" class="btn discrete">{{ 'general.Cancel' | translate }}</a></li>
        </ul>
    `
})
export default class {
    constructor (FormFactory, $state, $translate, ModalService) {
        this.$state = $state;
        this.$translate = $translate;
        this.ModalService = ModalService;
        this.form = FormFactory.createFromResource(this.surveyGroup, { expand: 'formActiveI18n' });
    }

    save () {
        if (!this.form.model.deadline) {
            const message = this.$translate.instant('survey.add_no_deadline_confirmation_message');
            this.ModalService.confirm(message, 'medium').then(() => {
                this.form.save().then((model) => {
                    this.$state.go('authorized.survey.detail', { id: model.id });
                });
            });
        }
        else {
            this.form.save().then((model) => {
                this.$state.go('authorized.survey.detail', { id: model.id });
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/add/index.js